import Vuex from 'vuex'

import homeDrushim from '@/store/modules/homeDrushim'
import authUser from '@/store/modules/authUser'
import smartAlertsSettings from '@/store/modules/smartAlertsSettings'
import cvwizard from '@/store/modules/cvwizard'

import { getters as authGetters } from '@/store/auth'

const store = () => {
    return new Vuex.Store({
        modules: {
            homeDrushim,
            authUser,
            smartAlertsSettings,
            cvwizard
        },
        getters: {
            ...authGetters,
        }
    })
}

export default store